import { useFieldArray, useFormContext, useWatch } from "react-hook-form";

import DeleteIcon from "@mui/icons-material/Delete";
import { Paper, Stack, Typography } from "@mui/material";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";

import { ProductVariantNameCell, useSnackbar } from "@/features/ui";
import { formatNumber } from "@/features/shared";

export const GeneralProductSection = () => {
  const { control } = useFormContext();
  const { showSnackbar } = useSnackbar();

  const { update, remove } = useFieldArray({
    control,
    name: "salesOrderProductVariants",
  });

  const productVariants = useWatch({
    control,
    name: "salesOrderProductVariants",
  });

  const handleDeleteClick = (id) => () => {
    // 🔍 Find index of the row with the matching id
    const index = productVariants.findIndex((variant) => variant.id === id);

    if (index !== -1) {
      remove(index);
      showSnackbar("Produk berhasil dihapus", "success");
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Nama",
      flex: 10,
      renderCell: ({ row: { name, sku } }) => (
        <ProductVariantNameCell name={name} sku={sku} />
      ),
    },
    {
      field: "costPerUnit",
      headerName: "@Harga",
      type: "number",
      flex: 3,
      valueFormatter: (value) => formatNumber(value),
    },
    {
      field: "quantity",
      headerName: "Qty",
      type: "number",
      flex: 2,
      editable: true,
      valueFormatter: (value) => formatNumber(value),
    },
    { field: "unitOfMeasurement", headerName: "Unit", flex: 2 },
    {
      field: "note",
      headerName: "Catatan",
      flex: 3,
      editable: true,
    },
    {
      field: "actions",
      type: "actions",
      getActions: ({ id }) => [
        <GridActionsCellItem
          key={id}
          icon={<DeleteIcon />}
          label="Hapus"
          className="textPrimary"
          onClick={handleDeleteClick(id)}
          color="error"
        />,
      ],
    },
  ];

  const processRowUpdate = (newRow, oldRow) => {
    const { quantity, maxQuantity } = newRow;

    if (quantity > maxQuantity) {
      showSnackbar(
        `Kuantitas tidak boleh lebih besar dari permintaan (max: ${maxQuantity})`
      );
      return oldRow;
    }

    if (quantity < 1) {
      showSnackbar("Kuantitas tidak boleh kurang dari 1");
      return oldRow;
    }

    // ✅ Find the index of the updated row and update only that row
    const index = productVariants.findIndex(
      (variant) => variant.id === newRow.id
    );
    if (index !== -1) {
      update(index, newRow);
    }

    return newRow; // ✅ If validation passes, return the updated row
  };

  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Stack spacing={2.5}>
        <Typography variant="h6">Pesanan Standard</Typography>
        <DataGrid
          getRowHeight={() => "auto"}
          editMode="row"
          columns={columns}
          rows={productVariants}
          processRowUpdate={processRowUpdate}
        />
      </Stack>
    </Paper>
  );
};
